import React from 'react';
import PropTypes from 'prop-types';
import { MetricsContent } from '../../../common/components/table/MetricsContent';
import { agentProductionTerms as t } from '../../../constants';

const Metrics = ({ columns, setColumns }) => {
    const handleSetColumns = ({ columnId, isDisplayed }) => {
        setColumns(columnId, { isDisplayed });
    };
    return (
        <div className='pt-3'>
            <h6>{t.metrics}</h6>
            <MetricsContent
                columns={columns}
                setColumns={handleSetColumns}
            />
        </div>
    );
};

Metrics.propTypes = {
    columns: PropTypes.array,
    setColumns: PropTypes.func,
};

export default Metrics;
